// import firebase from 'firebase/app';

export default {
  state: {
    currItemMenu: '',
    drawer: false,
    menu: [],
    menuh: [],
  },
  mutations: {
    setCurrentMenu(state, payload) {
      state.currItemMenu = payload
    },
    setMenu(state, payload) {
      state.menu = payload
    },
    setMenuHome(state, payload) {
      state.menuh = payload
    },
    setShowDrawer(state, payload) {
      state.drawer = payload
    }
  },
  actions: {
    setCurrentMenu: ({
      commit
    }, payload) => {
      commit('setCurrentMenu', payload)
    },
    setMenu: ({
      commit
    }, payload) => {
      commit('setMenu', payload)
    },
    setMenuHome: ({
      commit
    }, payload) => {
      commit('setMenuHome', payload)
    },
    updateDrawer: ({
      commit
    }, payload) => {
      commit('setShowDrawer', payload)
    }
  },
  getters: {
    getCurrItemMenu(state) {
      return state.currItemMenu
    },
    getMenu(state) {
      return state.menu
    },
    getMenuH(state) {
      return state.menuh
    },
    getShowDrawer(state) {
      return state.drawer
    }

  }
}
